module.exports = __webpack_public_path__ + "media/customizations/valenciasky/logo-new-d06fab9e8e8eb4880f8ad9135b43b91b.png";